import { render, staticRenderFns } from "./SelectClass.vue?vue&type=template&id=af8f8d6e&scoped=true"
import script from "./SelectClass.vue?vue&type=script&lang=js"
export * from "./SelectClass.vue?vue&type=script&lang=js"
import style0 from "./SelectClass.vue?vue&type=style&index=0&id=af8f8d6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af8f8d6e",
  null
  
)

export default component.exports